import { TypedUseSelectorHook, useSelector } from "react-redux";
import { CoreUiLayoutStoreSlice, coreuiLayoutReducer } from "../features";

export interface CoreUiStoreSlices {
  coreuiLayout: CoreUiLayoutStoreSlice;
}

export const coreuiReducers = {
  coreuiLayout: coreuiLayoutReducer,
};

export const useCoreUiTypedSelector: TypedUseSelectorHook<CoreUiStoreSlices> =
  useSelector;
